<template>
  <div style="overflow: hidden">
    <vs-col vs-justify="center" vs-align="center" vs-w="12">
      عنوان یادداشت:
      <vs-input v-model="currentNote.title" class="w-100 mt-1" />
    </vs-col>
    <vs-col
      v-for="(item, index) in currentNote.notes"
      vs-justify="center"
      vs-align="center"
      vs-w="12"
      class="mb-3"
      :key="index"
    >
      <p>متن {{ index + 1 }}</p>
      <div class="row">
        <vs-textarea
          v-model="currentNote.notes[index]"
          class="w-100 mt-1 mr-5"
        />
        <feather-icon
          icon="Trash2Icon"
          svgClasses="w-5 h-5 text-danger"
          class="trash-icon"
          @click="removeNote(index)"
        />
      </div>
    </vs-col>
    <vs-col vs-justify="center" vs-align="center" vs-w="12">
      <vs-button
        @click="addNote()"
        color="primary"
        block
        icon-pack="feather"
        icon="icon-plus"
        >ایجاد یادداشت جدید</vs-button
      >
    </vs-col>
    <vs-col>
      <div class="flex justify-end">
        <vs-button
          @click="confirm()"
          color="primary"
          class="mt-5 mb-5"
          block
          icon-pack="feather"
          icon="icon-check"
          >تایید</vs-button
        >
      </div>
    </vs-col>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Category",
  data() {
    const data = { ...this.note, notes: [...this.note.notes] };
    return {
      currentNote: { ...data },
    };
  },
  computed: mapGetters({
    currentProvider: "profile/currentProvider",
  }),
  methods: {
    confirm() {
      this.$emit("noteConfirmed", this.currentNote);
    },
    removeNote(index) {
      const _notes = [...this.currentNote.notes];
      this.currentNote = {
        ...this.currentNote,
        notes: _notes.filter((item, i) => i !== index),
      };
    },
    addNote() {
      this.currentNote.notes.push("");
    },
  },
  props: {
    note: {
      type: Object,
      requried: true,
    },
  },
};
</script>

<style scoped lang="scss">
.row {
  display: flex;
  align-items: center;
  justify-content: center;
}

.trash-icon {
  cursor: pointer;
}
</style>
